import { render, staticRenderFns } from "./AuthPanelRegister.vue?vue&type=template&id=19496d5c&scoped=true"
import script from "./AuthPanelRegister.vue?vue&type=script&lang=ts"
export * from "./AuthPanelRegister.vue?vue&type=script&lang=ts"
import style0 from "./AuthPanelRegister.vue?vue&type=style&index=0&id=19496d5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19496d5c",
  null
  
)

export default component.exports